var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Bot } from 'packages/bot/entities/Bot';
import env from 'config/env.js';
import { BotConversation } from 'packages/bot/entities/BotConversation';
import { EntityBuilder } from '@decahedron/entity';
var BotRepository = /** @class */ (function (_super) {
    __extends(BotRepository, _super);
    function BotRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'bot';
        _this.entity = Bot;
        _this.baseUrl = env.BOT_API;
        _this.responseTransformer = function (response) { return response.data; };
        return _this;
    }
    BotRepository.prototype.startNewConversation = function (botId, source) {
        var _this = this;
        return this.axios.post("" + this.baseUrl + botId + "/conversations", JSON.stringify({ source: source })).then(function (response) { return _this.responseTransformer(response).data; });
    };
    BotRepository.prototype.getConversationsForTalent = function (talentId) {
        var _this = this;
        return this.get(this.baseUrl + "conversations", null, { filters: { talent_id: talentId } })
            .then(function (response) { return _this.responseTransformer(response.data); })
            .then(function (response) { return EntityBuilder.buildMany(BotConversation, response); });
    };
    BotRepository.prototype.getBotsForCompany = function (companyId) {
        var _this = this;
        return this.get(this.baseUrl + "companies/:company_id/bots", { company_id: companyId })
            .then(function (response) { return _this.responseTransformer(response.data); });
    };
    return BotRepository;
}(AbstractRepository));
export { BotRepository };
